// src/seo/hreflang.js
import React from "react";
import { FRONTEND_URL } from "../config/urls";
import { buildRecipePathFromParts, getLocalizedField } from "../utils/recipeUrl";

export const PATH_LANGS = ["en", "en-US", "en-GB", "el"];

// regional -> locale path (en-US -> en-us), + normalize gr -> el
export const toPathLang = (code) => {
  const raw = String(code || "").trim().toLowerCase().replace("_", "-");
  if (raw === "gr" || raw === "el-gr") return "el";
  if (raw === "en-us") return "en-us";
  if (raw === "en-gb") return "en-gb";
  return raw.split("-")[0];
};

// (προαιρετικό) Facebook locale mapping για OG (χωρίς TS types σε .js)
export const FB_LOCALE = {
  el: "el_GR", gr: "el_GR",
  en: "en_US", "en-US": "en_US", "en-GB": "en_GB",
  es: "es_ES", sv: "sv_SE", ar: "ar_AR", ur: "ur_PK",
  de: "de_DE", fr: "fr_FR", it: "it_IT", ru: "ru_RU",
  sr: "sr_RS", hr: "hr_HR", ro: "ro_RO", sq: "sq_AL",
  bg: "bg_BG", zh: "zh_CN", "zh-CN": "zh_CN", "zh-HK": "zh_HK", "zh-TW": "zh_TW",
};

export function getRecipeHreflangLinks(recipe, defaultLang = "en") {
  if (!recipe?.id) return null;
  const links = PATH_LANGS.map((hl) => {
    const name = getLocalizedField(recipe, "name", hl) || "";
    const hrefPath = buildRecipePathFromParts({
      id: recipe.id,
      name,
      locale: hl,
    });
    return (
      <link
        key={hl}
        rel="alternate"
        hreflang={hl}
        href={`${FRONTEND_URL}${hrefPath}`}
      />
    );
  });
  links.push(
    <link
      key="x-default"
      rel="alternate"
      hreflang="x-default"
      href={`${FRONTEND_URL}${buildRecipePathFromParts({
        id: recipe.id,
        name: getLocalizedField(recipe, "name", defaultLang) || "",
        locale: defaultLang,
      })}`}
    />
  );
  return links;
}

export function getPathHreflangLinks(path = "/", defaultLang = "en") {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const links = PATH_LANGS.map((hl) => {
    const langPath = toPathLang(hl);
    return (
      <link
        key={hl}
        rel="alternate"
        hreflang={hl}
        href={`${FRONTEND_URL}/${langPath}${normalized}`}
      />
    );
  });
  links.push(
    <link
      key="x-default"
      rel="alternate"
      hreflang="x-default"
      href={`${FRONTEND_URL}/${toPathLang(defaultLang)}${normalized}`}
    />
  );
  return links;
}
